import {createSelector} from 'reselect';
import get from 'lodash/get';

import {getRankedBadges} from './listing';
import {getSiteName} from './system';

const MAX_BADGES = 6;

const badgeStyleConfig = {
    '32': {
        iconId: 'svg-yellow-star',
        bgColor: {
            vrbo: '#e4ebd5'
        }
    },
    '55': {
        bgColor: {
            default: '#8dc089'
        },
        textColor: 'rgba(0,0,0,0.85)'
    }
};

const createBadgeObj = (badge, site) => {
    let styleObj = {};
    const {id} = badge;

    if (badgeStyleConfig[id]) {
        const bgColor = get(badgeStyleConfig[id], 'bgColor');
        const iconId = get(badgeStyleConfig[id], 'iconId');
        const textColor = get(badgeStyleConfig[id], 'textColor');

        styleObj.bgColor = bgColor[site] || bgColor.default || null;
        styleObj.iconId = iconId || null;
        styleObj.textColor = textColor || null;
    }

    return {
        ...styleObj,
        ...badge
    };
};

const getBadgeArray = (badges, site) => {
    return badges.reduce((arr, badge) => {
        if (badge.name && badge.id) {
            arr.push(createBadgeObj(badge, site));
            return arr;
        }
        return arr;
    }, []);
};

const getListingOverviewBadges = createSelector(
    [getSiteName, getRankedBadges],
    (site, rankedBadges) => {
        return getBadgeArray(rankedBadges, site).splice(0, MAX_BADGES);
    }
);

export default getListingOverviewBadges;
export {getListingOverviewBadges};
